"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Worker = void 0;
const CardType_1 = require("../../cards/CardType");
const IAward_1 = require("../IAward");
class Worker {
    constructor() {
        this.name = 'Worker';
        this.description = 'Have the most active (blue) action cards';
    }
    getScore(player) {
        let score = player.playedCards.filter((card) => card.cardType !== CardType_1.CardType.PRELUDE).filter((card) => card.action !== undefined).length;
        player.corporationCards.forEach((corp) => {
            if (corp.action !== undefined)
                score += 1;
        });
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Worker = Worker;
//# sourceMappingURL=Worker.js.map